import { BoolPropertyViewModel } from './base-type';
import { AuditViewModelInterface } from './audit-view-model.interface';

export class OCCAuditDeactivableViewModelInterface extends AuditViewModelInterface {
    isActive: BoolPropertyViewModel;
}
